import React from 'react';
// import PropTypes from 'prop-types'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

export default class Theme extends React.Component {
  render() {
    const { children } = this.props;

    const colorGold = '#998778';
    const colorSilver = '#6b6b6b';
    const colorSecondary = '#DC3E81';
    const theme = createMuiTheme({
      palette: {
        primary: { main: colorGold, light: colorGold, dark: colorGold, contrastText: '#fff' },
        secondary: { main: colorSecondary, light: colorSilver, dark: colorSilver, contrastText: '#fff' },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      typography: {
        fontFamily: ['Source Sans Pro, Helvetica, Arial, sans-serif'].join(','),
        useNextVariants: true,
        h1: {
          // color: '#747273',
          color: '#332F30',
          fontWeight: 700,
          fontFamily: 'Megatype',
          fontSize: '3.5rem',
          position: 'relative',
          paddingBottom: 40,
          '& span': {
            color: colorSecondary,
          },
          '&:after': {
            // borderBottom: '5px ' + colorSecondary + ' solid',
            backgroundColor: colorSecondary,
            borderRadius: 90,
            height: 4,
            width: '10%',
            content: "' '",
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: 0,
          },
        },
        h2: {
          // color: '#747273',
          color: '#322F30',
          fontFamily: 'Megatype',
          fontSize: '2rem',
          fontWeight: 700,
        },
        h3: {
          // color: '#747273',
          color: '#332F30',
          fontWeight: 700,
          fontFamily: 'Megatype',
          fontSize: '2rem',
          margin: '20px 0 30px',
          paddingBottom: 20,
          position: 'relative',
          width: 'auto',
          '&$gutterBottom': {
            margin: '30px 0 40px',
          },
          '&:after': {
            // borderBottom: '5px ' + colorSecondary + ' solid',
            backgroundColor: colorSecondary,
            borderRadius: 90,
            height: 4,
            width: '100px',
            content: "' '",
            position: 'absolute',
            left: 0,
            bottom: 0,
          },
        },

        h4: {
          color: '#747273',
          fontFamily: 'Megatype',
          fontSize: '1.1rem',
          marginBottom: '20px',
        },
        h6: {
          fontFamily: 'Megatype',
          fontSize: '1.2rem',
          color: '#747273',
        },
        body1: {
          color: '#747273',
        },
        subtitle1: {
          color: '#747273',
        },
        subtitle2: {
          color: '#747273',
        },
      },
      overrides: {
        MuiPaper: {
          rounded: {
            borderRadius: 6,
          },
        },
        MuiDivider: {
          root: {
            backgroundColor: 'transparent',
            borderTop: '1px dashed #ccc',
          },
        },
        MuiButton: {
          root: {
            color: colorGold, // Some CSS
            backgroundColor: '#eee',
            fontFamily: 'Megatype',
            fontWeight: '700',
            textTransform: 'none',
          },
          contained: {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
            '&:active': {
              boxShadow: 'none',
            },
          },
          containedSecondary: {
            backgroundColor: colorSecondary,
            borderRadius: 30,
            padding: '10px 20px',
            border: '2px ' + colorSecondary + ' solid',
            '&:hover': {
              backgroundColor: '#fff',
              color: colorSecondary,
              borderColor: colorSecondary,
            },
          },
        },
        MuiInput: {
          root: {
            color: colorGold,
          },
        },
        MuiTypography: {
          h1: {},
        },
      },
    });

    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx